import React from 'react'
import PropTypes from 'prop-types';
import Sample from '../sample'

// import ApiService from '../../workspace/api/api-service'

import Radios from '../form/form-radios'
import Switch from '../form/form-switch'
import Anchor from '../form/form-anchor'
import Text from '../form/form-text'
import Search from '../form/form-search'
import Select from '../form/form-select'
import SwitchAsync from '../form/form-switch-async'
import ColorPicker from '../form/form-colorPicker'
import FileUpload from '../form/upload/files'
import DatePicker from '../form/form-datepicker'
import DateTimePicker from '../form/form-date-time-picker'
import Video from '../form/video/video'


//FIXME: create tools class ???
const onSuccess = e => new Promise(resolve => setTimeout(() => resolve(e), 1000))
const onError = e => new Promise((resolve, reject) => setTimeout(() => reject(e), 1000));

import './index.styl'
class FormSample extends Sample {
    state = {}
    i18n = 'sample.app.components.form.'

    constructor(props) {
        super(props)

        this.getTitle = this.getTitle.bind(this)
        this.getBody = this.getBody.bind(this)
    }

    componentDidMount() {
        this.forceUpdate()
    }

    getTitle() {
        return this.i18n + 'page.title'
    }

    getBody() {
        let {i18n} = this
        let radios1 =  Array.from(new Array(5), (x,i) => i).map((x, i) => ({id: i, name: 'element_' + i, value: false}) )
        let radios2 = JSON.parse(JSON.stringify(radios1));
        let radios3 = JSON.parse(JSON.stringify(radios1));
        let select1 =  Array.from(new Array(10), (x,i) => i).map((x, i) => ({id: i, name: 'element_' + i, value: 'Element-' + i}) )
        let search = select1.map(e => 'Component ' + e.value);

        return <div className="sample sample-form">

            {this.service && <Video video={{id: 1, src: this.service.get("/flux/videos/3242342"), type: "video/mp4", poster: 'http://s1.lprs1.fr/images/2017/06/29/7097913_noxk63eu_1000x625.jpg'}} />}

            <Anchor href="http://www.google.fr" label="Google" />

            <Radios onChange={onSuccess} options={radios2} name={'sample-radio-onSuccess'} label={i18n + 'radios.onSuccess'}  />
            <Radios onChange={onError} options={radios3} name={'sample-radio-onError'} label={i18n + 'radios.onError'}  />

            <DatePicker onChange={onSuccess} dateFormat='DD MMMM YYYY' label={i18n + 'datepicker.onSuccess'} />
            <DatePicker onChange={onError} dateFormat='DD MMMM YYYY' label={i18n + 'datepicker.onError'} />

            <DateTimePicker onChange={onSuccess} dateFormat='HH:mm - DD MMMM YYYY' label={i18n + 'datepicker.onSuccess'} />
            <DateTimePicker onChange={onError} dateFormat='HH:mm - DD MMMM YYYY' label={i18n + 'datepicker.onError'} />

            <Text onChange={onSuccess} label={i18n + 'text.onSuccess'} />
            <Text onChange={onError} label={i18n + 'text.onError'} />


            <Select options={select1} onChange={onSuccess}  label={i18n + 'select.onSuccess'} />
            <Select options={select1} onChange={onError}  label={i18n + 'select.onError'} />

            <Search onSelect={console.log} onChange={value => onSuccess(search)} label={i18n + 'select.onSuccess'} />
            <Search onSelect={console.log} onChange={onError} label={i18n + 'select.onError'} />

            <Switch onChange={(e) => true} label={i18n + 'switch.classic'} defaultChecked={true} />
            <SwitchAsync onChange={onError} label={i18n + 'switchAsync.onError'} />
            <SwitchAsync onChange={onError} label={i18n + 'switchAsync.onError'} checked={true}/>
            <SwitchAsync onChange={onSuccess} label={i18n + 'switchAsync.onSuccess'} />

            <ColorPicker onChange={onSuccess} label={i18n + 'colorPicker.onSuccess'} />

            <FileUpload upload={onSuccess} label={i18n + 'upload.onSuccess'} />
        </div>
    }
}

export default FormSample
